import React from 'react';
import { KPICardWrapper, RemoveButton, ButtonWrapper, MiddleWrapper, KPINumber } from './KPICard.styled';

const KPICard = (props) => (
 <KPICardWrapper isTotal={props.isTotal}>
   <ButtonWrapper>
    {props.isTotal || !props.allowRemove ? null: <RemoveButton onClick={props.handleRemove}>x</RemoveButton>}
   </ButtonWrapper>
   <MiddleWrapper>
    <KPINumber>{props.number}</KPINumber>
    <div>{props.label}</div>
   </MiddleWrapper>
 </KPICardWrapper>
);

KPICard.propTypes = {};

KPICard.defaultProps = {};

export default KPICard;
